// extracted by mini-css-extract-plugin
export var dateLabel = "_31-0";
export var dateLabelError = "_31-1";
export var fullWidth = "_31-2";
export var smaller = "_31-3";